import { tv } from '@/libs/tv'
import { Icons } from '@journ/ui/icons'
import { Input } from '@journ/ui/input'
import type { ChangeEvent, ComponentProps } from 'react'

const rootStyles = tv({ base: 'relative w-full md:max-w-95' })

const Root = ({ className, children }: ComponentProps<'div'>) => (
	<div className={rootStyles({ class: className })}>{children}</div>
)

type InputProps = {
	placeholder: string
	value: string
	onChange: (value: string | null) => void
} & Omit<ComponentProps<'input'>, 'onChange' | 'value'>

const SearchInput = ({ placeholder, value, onChange, className, ...props }: InputProps) => {
	const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
		onChange(e.target.value || null)
	}

	return (
		<>
			<Icons.Search size={16} className='absolute pointer-events-none left-3 top-2.75 text-muted-foreground' />
			<Input
				placeholder={placeholder}
				className={tv({ base: 'pl-9 w-full' })({ class: className })}
				value={value}
				onChange={handleChange}
				autoComplete='off'
				autoCapitalize='none'
				autoCorrect='off'
				spellCheck={false}
				{...props}
			/>
		</>
	)
}

const Action = ({ children, className }: ComponentProps<'div'>) => (
	<div className={tv({ base: 'absolute right-3 top-2.5' })({ class: className })}>{children}</div>
)

// Convenience wrapper — keeps existing callers unchanged.
type SearchFieldProps = InputProps & {
	containerClassName?: string
}

const SearchField = ({ containerClassName, placeholder, value, onChange, ...props }: SearchFieldProps) => (
	<Root className={containerClassName}>
		<SearchInput placeholder={placeholder} value={value} onChange={onChange} {...props} />
	</Root>
)

SearchField.Root = Root
SearchField.Input = SearchInput
SearchField.Action = Action

export { SearchField }
